import React from 'react';

import Card from '../../components/Card/Card';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';

import styles from './FeesExpenses.css';

import { ETF_FEES_EXPENSES, FEES_EXPENSES } from './queries';
import {
    isContractualETF,
    showExpenseWaiverDisclaimer
} from '../../utils/fund-info';
import { feesExpensesUtil, disclaimerNumbersFeeExpenses } from './util';

const FeesExpenses = ({ etf, ticker, iClass, moneyMarket, bond }) => (
    <Card>
        <GqlQueryWrapper
            query={etf ? ETF_FEES_EXPENSES : FEES_EXPENSES}
            variables={{ ticker }}
            dataFunc={feesExpensesUtil(iClass, moneyMarket, bond, ticker, etf)}
            placeholder={() => <TablePreRender />}
        >
            {({ data: { data, title } }) => (
                <div className="container">
                    <TitleWithDescription title={title} />
                    <Table rowBars data={{ data }} />
                </div>
            )}
        </GqlQueryWrapper>

        {isContractualETF(ticker) && (
            <div className="disclaimer disclaimer-large">
                The expense waiver type is Contractual. Expense Limitation does
                not expire as T. Rowe Price Associates, Inc., is required to
                permanently waive a portion of its management fee. See
                prospectus for more details on expense waiver.
            </div>
        )}

        <div className="disclaimer">
            <sup>{disclaimerNumbersFeeExpenses(iClass, moneyMarket, bond)}</sup>The
            gross expense ratio reflects the fund expenses as stated in the fee
            table of the fund&rsquo;s prospectus prior to the deduction of any
            waiver or reimbursement. The net expense ratio reflects fund
            expenses after the deduction of any waiver or reimbursement. Expense
            ratios are as of the most recent prospectus.
        </div>

        {[
            'PPIPX',
            'PRCIX',
            'PRSIX',
            'PRSNX',
            'PRXEX',
            'PTKIX',
            'PTTFX',
            'RBAIX',
            'RPBAX',
            'TGAFX',
            'TGIPX',
            'TPPAX',
            'TRPBX',
            'TRSGX',
            'TMSSX',
            'TTOIX'
        ].includes(ticker) && (
            <div className="disclaimer">
                T.&nbsp;Rowe&nbsp;Price Associates, Inc. is required to
                permanently waive a portion of its management fee charged to the
                fund in an amount sufficient to fully offset any acquired fund
                fees and expenses related to investments in other
                T.&nbsp;Rowe&nbsp;Price mutual funds. The amount of the waiver
                will vary each fiscal year in proportion to the amount invested
                in other T.&nbsp;Rowe&nbsp;Price mutual funds.
            </div>
        )}
        {ticker === 'TGAFX' && (
            <div className="disclaimer">
                The fund&apos;s net expense ratio excludes expenses permanently
                waived as a result of investments in other
                T.&nbsp;Rowe&nbsp;Price mutual funds and expenses that were
                waived or borne by T.&nbsp;Rowe&nbsp;Price pursuant to the
                fund&apos;s expense limitation, but includes expenses associated
                with investments in non-T.&nbsp;Rowe&nbsp;Price investment
                companies.
            </div>
        )}

        {ticker === 'RPGAX' && (
            <div className="disclaimer">
                As a result of other class&apos; expense limitations,
                T.&nbsp;Rowe&nbsp;Price Associates, Inc. waived fund-level
                expenses ratably across all classes. The fund&apos;s net expense
                ratio excludes expenses permanently waived as a result of
                investments in other T.&nbsp;Rowe&nbsp;Price mutual funds and
                expenses that were waived or borne by T.&nbsp;Rowe&nbsp;Price
                pursuant to the fund&apos;s expense limitation, but includes
                expenses associated with investments in
                non-T.&nbsp;Rowe&nbsp;Price Investment companies.
            </div>
        )}

        {ticker === 'VEIEX' && (
            <div className="disclaimer">
                This fund has a transaction fee of .5% of the principal amount
                of the transaction, which is in addition to the $35.00
                transaction fee charged by T. Rowe Price.
            </div>
        )}
        {etf || (
            <GqlQueryWrapper query={FEES_EXPENSES} variables={{ ticker }}>
                {({
                    data: {
                        mutualFund: {
                            transactionFee,
                            activeMoneyMarketFundMessages
                        }
                    }
                }) => (
                    <React.Fragment>
                        {transactionFee && (
                            <div className="disclaimer">
                                T.&nbsp;Rowe&nbsp;Price Associates, Inc. is
                                required to permanently waive a portion of its
                                management fee charged to the fund in an amount
                                sufficient to fully offset any acquired fund
                                fees and expenses related to investments in
                                other T.&nbsp;Rowe&nbsp;Price mutual funds. The
                                amount of the waiver will vary each fiscal year
                                in proportion to the amount invested in other
                                T.&nbsp;Rowe&nbsp;Price mutual funds.
                            </div>
                        )}
                        {moneyMarket &&
                            Boolean(activeMoneyMarketFundMessages.length) && (
                                <div className="disclaimer">
                                    <sup>&#94;</sup> The fund generally does not
                                    charge a redemption fee but may impose a
                                    liquidity fee upon the sale of your shares
                                    or may temporarily suspend your ability to
                                    see shares if the Fund&apos;s liquidity
                                    falls below required minimums because of
                                    market conditions or other factors.
                                </div>
                            )}
                        {showExpenseWaiverDisclaimer(ticker) && (
                            <div className="disclaimer">
                                * T. Rowe Price Associates, Inc., has
                                contractually agreed to permanently waive any
                                expenses that would cause the class&apos; ratio
                                of expenses to average daily net assets to
                                exceed the net expense ratio listed above. This
                                waiver may only be terminated by approval of the
                                fund&apos;s shareholders. Fees waived and
                                expenses paid under the fund&apos;s contractual
                                expense limitation arrangement are subject to
                                reimbursement to T. Rowe Price Associates by the
                                fund whenever the fund&apos;s expense ratio is
                                below a certain level. See the prospectus for
                                details.
                            </div>
                        )}
                    </React.Fragment>
                )}
            </GqlQueryWrapper>
        )}
        <style jsx>{styles}</style>
    </Card>
);

export default FeesExpenses;
